import { ActionTypes } from "../constants/action-types"

const initialState = {
    uploadNewTutorialTopic:[]

}

export const UploadTutorialTopic = (state=initialState, {type, payload})=>{
switch (type){
    case ActionTypes.UPLOAD_TUTORIAL_TOPIC: 
    return {...state, uploadNewTutorialTopic: payload}
    default: return state
}

}